module.exports = __webpack_public_path__ + "static/media/Global Airport Transfer.9634b3b3.png";